// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
}

.App {
  display: flex;
  align-items: center;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  flex-direction: column;
}
.otherPrices{
  padding: 5px;
  background-color: rgb(236, 166, 60);
  border-radius: 7px;
  cursor: pointer;


}
.card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  flex-direction: row;
  align-self: center;
  margin: 10px;
  word-wrap: break-word;
  
}
.artisticText{
  font-family:cursive;
  font-size:16;
}
.logo{
  width: 220px;
  height: 120px;
  object-fit: contain;
  margin: 10px;
  cursor: pointer;
}
.reklam{
  width: 80px;
  height: 30px;
  object-fit: contain;
margin: 5px;
}
.grayText{
  color: rgb(173, 170, 170);
  text-align: center;
  margin-top: 10px;
}
.alert {
  padding: 20px;
  color: white;
  text-align: center;
  border-radius: 5px;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.alert.success {
  background-color: green;
}

.alert.error {
  background-color: red;
}



/* @media (min-width: 768px) {
  .social-icon {
    width: 30px;
    height: 30px;
  }
} */

/* Yazı tipi boyutları için medya sorguları */
p, h1 {
  margin: 0; /* Margin sıfırlamak, padding ile yazıları hizalamaya yardımcı olur */
}

/* Telefonlar için yazı boyutları */
@media (max-width: 599px) {
  .card{
    padding: 20px;
  }
  p {
    font-size: 12px;
  }
  img{
    width: 20px;
    height: 20px;
  }
  h1 {
    font-size: 18px;
  }
  .smallh1{
    font-size: 15px;
  }
  th {
    font-size: 12px;
  }
  td {
    font-size: 12px;
  }
.logo{
  width: 200px;
  height: 80px;
}
.reklam{
  width: 60px;
  height: 20px;
}
.artisticText{
  font-size: 16;
}
}

/* Tabletler için yazı boyutları */
@media (min-width: 600px) and (max-width: 899px) {
  .card{
    padding: 30px;
  }
  p {
    font-size: 15px;
  }
  img{
    width: 25px;
    height: 25px;
  }
  h1 {
    font-size: 20px;
  }
  .smallh1{
    font-size: 17px;
  }
  th {
    font-size: 15px;
  }
  td {
    font-size: 15px;
  }
  .logo{
    width: 220px;
    height: 100px;
  }
  .reklam{
    width: 80px;
    height: 30px;
  }
  .artisticText{
    font-size: 18;
  }
}

/* Masaüstü tarayıcılar için yazı boyutları */
@media (min-width: 900px) {
  .card{
    padding: 40px;
  }
  p {
    font-size: 16px;
  }
  img{
    width: 30px;
    height: 30px;
  }
  h1 {
    font-size: 22px;
  }
  .smallh1{
    font-size: 19px;
  }
  th {
    font-size: 16px;
  }
  td {
    font-size: 16px;
  }
  .logo{
    width: 260px;
    height: 100px;
  }
  .reklam{
    width: 100px;
    height: 35px;
  }
  .artisticText{
    font-size: 20;
  }
}

/* büyük ekranlar için yazı boyutları */
@media (min-width: 1200px) {
  .card{
    padding: 40px;
  }
  p {
    font-size: 20px;
  }
  img{
    width: 35px;
    height: 35px;
  }
  h1 {
    font-size: 28px;
  }
  .smallh1{
    font-size: 24px;
  }
  th {
    font-size: 20px;
  }
  td {
    font-size: 20px;
  }
  .logo{
    width: 300px;
    height: 120px;
   
  
  }
  .reklam{
    width: 120px;
    height: 40px;
  }
  .artisticText{
    font-size: 22;
  }
}

.rowTable {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap; /* Ekran küçük olduğunda satırları sarmaya yardımcı olur */
}
.container {
  padding: 10px;
}

.initial-number {
  font-size: 1.0em;
}

.fraction {
  font-size: 0.85em;
  color: rgb(37, 37, 37);
}


.oneRow {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 30px; /* 30px sağ boşluk */
}

.scaleUp{
  transition: transform 0.3s;
}

.scaleUp:hover{
  transform: scale(1.2);
}

.invoice-table th, .invoice-table td {
  border: 1px solid #f4f2ec;
  text-align: center;
}
.invoice-table {
  margin: 0 auto; /* Center the table horizontally */
}
.box1{
  background-color: rgb(244, 244, 244);
}
.box2{
  background-color: rgb(224, 224, 224);

}
.box3{
  background-color: rgb(168, 168, 168);

}






`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yDAAiD;EACjD,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;;;AAGjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;;AAEvB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB,WAAW;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;;;;;GAKG;;AAEH,6CAA6C;AAC7C;EACE,SAAS,EAAE,qEAAqE;AAClF;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;;;EAGf;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe,EAAE,0DAA0D;AAC7E;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc,EAAE,kCAAkC;AACpD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;;AAEtC;AACA;EACE,oCAAoC;;AAEtC","sourcesContent":["body, html {\n  height: 100%;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.App {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  background-image: url('../assets/background.jpg');\n  background-size: cover;\n  background-position: center;\n  flex-direction: column;\n}\n.otherPrices{\n  padding: 5px;\n  background-color: rgb(236, 166, 60);\n  border-radius: 7px;\n  cursor: pointer;\n\n\n}\n.card {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  flex-direction: row;\n  align-self: center;\n  margin: 10px;\n  word-wrap: break-word;\n  \n}\n.artisticText{\n  font-family:cursive;\n  font-size:16;\n}\n.logo{\n  width: 220px;\n  height: 120px;\n  object-fit: contain;\n  margin: 10px;\n  cursor: pointer;\n}\n.reklam{\n  width: 80px;\n  height: 30px;\n  object-fit: contain;\nmargin: 5px;\n}\n.grayText{\n  color: rgb(173, 170, 170);\n  text-align: center;\n  margin-top: 10px;\n}\n.alert {\n  padding: 20px;\n  color: white;\n  text-align: center;\n  border-radius: 5px;\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n.alert.success {\n  background-color: green;\n}\n\n.alert.error {\n  background-color: red;\n}\n\n\n\n/* @media (min-width: 768px) {\n  .social-icon {\n    width: 30px;\n    height: 30px;\n  }\n} */\n\n/* Yazı tipi boyutları için medya sorguları */\np, h1 {\n  margin: 0; /* Margin sıfırlamak, padding ile yazıları hizalamaya yardımcı olur */\n}\n\n/* Telefonlar için yazı boyutları */\n@media (max-width: 599px) {\n  .card{\n    padding: 20px;\n  }\n  p {\n    font-size: 12px;\n  }\n  img{\n    width: 20px;\n    height: 20px;\n  }\n  h1 {\n    font-size: 18px;\n  }\n  .smallh1{\n    font-size: 15px;\n  }\n  th {\n    font-size: 12px;\n  }\n  td {\n    font-size: 12px;\n  }\n.logo{\n  width: 200px;\n  height: 80px;\n}\n.reklam{\n  width: 60px;\n  height: 20px;\n}\n.artisticText{\n  font-size: 16;\n}\n}\n\n/* Tabletler için yazı boyutları */\n@media (min-width: 600px) and (max-width: 899px) {\n  .card{\n    padding: 30px;\n  }\n  p {\n    font-size: 15px;\n  }\n  img{\n    width: 25px;\n    height: 25px;\n  }\n  h1 {\n    font-size: 20px;\n  }\n  .smallh1{\n    font-size: 17px;\n  }\n  th {\n    font-size: 15px;\n  }\n  td {\n    font-size: 15px;\n  }\n  .logo{\n    width: 220px;\n    height: 100px;\n  }\n  .reklam{\n    width: 80px;\n    height: 30px;\n  }\n  .artisticText{\n    font-size: 18;\n  }\n}\n\n/* Masaüstü tarayıcılar için yazı boyutları */\n@media (min-width: 900px) {\n  .card{\n    padding: 40px;\n  }\n  p {\n    font-size: 16px;\n  }\n  img{\n    width: 30px;\n    height: 30px;\n  }\n  h1 {\n    font-size: 22px;\n  }\n  .smallh1{\n    font-size: 19px;\n  }\n  th {\n    font-size: 16px;\n  }\n  td {\n    font-size: 16px;\n  }\n  .logo{\n    width: 260px;\n    height: 100px;\n  }\n  .reklam{\n    width: 100px;\n    height: 35px;\n  }\n  .artisticText{\n    font-size: 20;\n  }\n}\n\n/* büyük ekranlar için yazı boyutları */\n@media (min-width: 1200px) {\n  .card{\n    padding: 40px;\n  }\n  p {\n    font-size: 20px;\n  }\n  img{\n    width: 35px;\n    height: 35px;\n  }\n  h1 {\n    font-size: 28px;\n  }\n  .smallh1{\n    font-size: 24px;\n  }\n  th {\n    font-size: 20px;\n  }\n  td {\n    font-size: 20px;\n  }\n  .logo{\n    width: 300px;\n    height: 120px;\n   \n  \n  }\n  .reklam{\n    width: 120px;\n    height: 40px;\n  }\n  .artisticText{\n    font-size: 22;\n  }\n}\n\n.rowTable {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap; /* Ekran küçük olduğunda satırları sarmaya yardımcı olur */\n}\n.container {\n  padding: 10px;\n}\n\n.initial-number {\n  font-size: 1.0em;\n}\n\n.fraction {\n  font-size: 0.85em;\n  color: rgb(37, 37, 37);\n}\n\n\n.oneRow {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-right: 30px; /* 30px sağ boşluk */\n}\n\n.scaleUp{\n  transition: transform 0.3s;\n}\n\n.scaleUp:hover{\n  transform: scale(1.2);\n}\n\n.invoice-table th, .invoice-table td {\n  border: 1px solid #f4f2ec;\n  text-align: center;\n}\n.invoice-table {\n  margin: 0 auto; /* Center the table horizontally */\n}\n.box1{\n  background-color: rgb(244, 244, 244);\n}\n.box2{\n  background-color: rgb(224, 224, 224);\n\n}\n.box3{\n  background-color: rgb(168, 168, 168);\n\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
